









































import {Component, Mixins, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import {Portal} from '@linusborg/vue-simple-portal'
import anime from "animejs"
import TextProviderMixin from "@/design-system/utilities/TextProviderMixin"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import AnalyticsEmitterMixin
    from "@/design-system/foundation/AnalyticsProvider/AnalyticsEmitterMixin"


@Component({
    components: {SimplePortal: Portal}
})
export default class JdhModalDialog extends Mixins(TextProviderMixin, UniqueIdMixin, AnalyticsEmitterMixin) {
    @Prop({default: false, type: Boolean}) visible!: boolean
    @Prop({default: false, type: Boolean}) flipped!: boolean
    @Prop({default: false, type: Boolean}) allowOverflow!: boolean
    @Prop({default: 'normal'}) size!: 'normal'|'wide'|'narrow'

    @Ref() popupEl!: HTMLElement
    @Ref() backsideEl!: HTMLElement
    @Ref() backdropEl!: HTMLElement
    lastResult = false

    get state() {
        return this.visible
    }

    @Watch('visible')
    syncListeners() {
        if (this.visible) {
            document.addEventListener('keyup', this.handleGlobalKeyup)
        } else {
            document.removeEventListener('keyup', this.handleGlobalKeyup)
        }
    }

    handleBackdropClick() {
        this.$emit('dismiss')
    }

    handleGlobalKeyup(e: KeyboardEvent) {
        if (e.key === 'Escape') {
            this.$emit('dismiss', e)
        }
    }

    enter(el: Node, done: ()=>void) {
        anime.timeline({
            easing: 'easeInOutExpo',
            complete: () => {
                try {
                    this.popupEl.style.removeProperty("height");
                } catch (e) {}
                done();
            },
        }).add({
            targets: this.popupEl,
            opacity: [0, 1],
            scale: [0.8, 1],
            translateY: ['15px', 0],
            duration: 250,
            easing: 'easeOutBack',
        }).add({
            targets: this.backdropEl,
            opacity: [0, 1],
            duration: 250,
            easing: 'easeOutExpo'
        }, 0)
    }

    leave(el: Node, done: ()=>void) {
        if (this.lastResult === 'cancel') {
            anime.timeline({
                complete: done,
            }).add({
                targets: this.popupEl,
                opacity: ['100%', '0%'],
                scale: [1, 0.8],
                duration: 200,
                easing: 'easeInCubic',
                complete: done,
            }).add({
                targets: this.backdropEl,
                opacity: [1, 0],
                duration: 200,
                easing: 'linear'
            }, 0)
        } else {
            anime.timeline({
                complete: done,
            }).add({
                targets: this.popupEl,
                opacity: ['100%', '0%'],
                scale: [1, 1.08],
                duration: 140,
                easing: 'easeInCubic',
                complete: done,
            }).add({
                targets: this.backdropEl,
                opacity: [1, 0],
                duration: 200,
                easing: 'linear'
            }, 0)
        }
    }

    flipEnter(el: Node, done: ()=>void) {
        anime.timeline({
            easing: 'easeInOutSine',
            complete: done,
        }).add({
            targets: el,
            rotateY: ['-180deg', 0],
            duration: 500,
        })
    }

    flipLeave(el: Node, done: ()=>void) {
        anime.timeline({
            easing: 'easeInOutSine',
            complete: done,
        }).add({
            targets: el,
            rotateY: [0, '180deg'],
            duration: 500,
        })
    }
}
